import React from 'react';
import { FormattedMessage } from 'react-intl';

export const UnsavedChangesTitle = () => (
  <FormattedMessage id="unsavedChangesPrompt.title" />
);

export default UnsavedChangesTitle;
